import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"],
  _excluded2 = ["type"];
/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-misused-promises */

import { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error untyped dependency
import { postNotification } from 'ReduxMessenger/actions/NotificationActions';
import { H1 } from 'foundations-components/transitional/components/H1';
import { H2 } from 'foundations-components/transitional/components/H2';
import { H5 } from 'foundations-components/transitional/components/H5';
import { Small } from 'foundations-components/transitional/components/Small';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { Box } from 'foundations-components/transitional/components/Box';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { MediaObject } from 'foundations-components/transitional/components/MediaObject';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { Section } from 'foundations-components/transitional/components/Section';
import { formatCentsToDollars } from 'marketplace-ui-common/utils/currency';
import * as PostMessageType from 'marketplace-embed/constants/PostMessageType';
import { isPending, isFailed, isSucceeded } from 'marketplace-ui-common/requestStates/RequestStateUtils';
import { getDownloadedAssetsSuccessUrl } from 'marketplace-ui-assets-core/utils/urls';
// @ts-expect-error untyped dependency
import * as PaymentType from '../../constants/PaymentType';
import { getDetailPageFullUrl } from '../../utils/urls';
import { purchase } from '../../clients/ecosystemClient';
// @ts-expect-error untyped dependency
import { useEmbedContext } from '../../hooks/useEmbedContext';
import CurrencyText from './CurrencyText';
import StorefrontUsageTrackerContext from '../../context/StorefrontUsageTrackerContext';
import { View } from 'foundations-components/components/View';
import { Link } from 'foundations-components/transitional/components/Link';
import { SelectableBox } from 'foundations-components/transitional/components/SelectableBox';
import { ToggleGroup } from 'foundations-components/transitional/components/ToggleGroup';
import { Flex } from 'foundations-components/components/Flex';
import { Image } from 'foundations-components/transitional/components/Image';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HUBSPOT_PRIVACY_POLICY_LINK = 'https://legal.hubspot.com/privacy-policy';
const SUBSCREEN = 'order summary modal';
const NoopExternalIcon = () => null;
const ExternalLink = props => /*#__PURE__*/_jsx(Link, Object.assign({}, props, {
  ExternalIcon: NoopExternalIcon,
  external: true
}));
const SelectableRadioInput = _ref => {
  let {
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(View, {
    inlineSize: "50%",
    children: /*#__PURE__*/_jsx(SelectableBox, Object.assign({}, rest, {
      selectionMarkLocation: "left",
      type: "radio",
      children: /*#__PURE__*/_jsx(TFlex, {
        direction: "row",
        align: "center",
        paddingInlineStart: "500",
        children: children
      })
    }))
  });
};
const handleStripeCheckoutError = result => {
  postNotification({
    id: 'STRIPE_CHECKOUT_ERROR',
    type: 'danger',
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "marketplace-assets-ui.details.orderSummaryModal.errorTitle"
    }),
    message: result.error.message
  });
};
const handleGenericCheckoutError = () => postNotification({
  type: 'danger',
  titleText: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "marketplace-assets-ui.details.orderSummaryModal.errorTitle"
  }),
  message: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "marketplace-assets-ui.details.orderSummaryModal.errorBody"
  })
});
export default function AssetOrderSummaryModal({
  assetDetails,
  offeringType,
  onClose
}) {
  const {
    name,
    offeringId,
    paypalEnabled,
    provider: {
      name: providerName
    },
    pricing: {
      cents,
      planType
    },
    privacyUrl,
    slug,
    stripeEnabled,
    termsUrl,
    thumbnailUrl
  } = assetDetails;
  const incomingPaymentType = useMemo(() => {
    if (planType === 'FREE') {
      return PaymentType.FREE;
    } else if (stripeEnabled && !paypalEnabled) {
      return PaymentType.STRIPE;
    } else if (paypalEnabled && !stripeEnabled) {
      return PaymentType.PAYPAL;
    }
    return null;
  }, [paypalEnabled, planType, stripeEnabled]);
  const {
    trackEvent,
    trackDetailsInteraction,
    trackDetailsPageview
  } = useContext(StorefrontUsageTrackerContext);
  const [purchaseRequestState, setPurchaseRequestState] = useState('UNINITIALIZED');
  const [selectedPaymentType, setSelectedPaymentType] = useState(incomingPaymentType);
  const handleTrackInteraction = useCallback((action, eventProperties = {}) => {
    trackDetailsInteraction(action, Object.assign({}, eventProperties, {
      subscreen: SUBSCREEN
    }));
  }, [trackDetailsInteraction]);
  const handleTrackInstallUsage = useCallback(() => {
    let paymentType;
    if (selectedPaymentType === PaymentType.FREE) {
      paymentType = 'free';
    } else if (selectedPaymentType === PaymentType.STRIPE) {
      paymentType = 'stripe';
    } else if (selectedPaymentType === PaymentType.PAYPAL) {
      paymentType = 'paypal';
    }
    trackEvent('details-click-install', {
      subscreen: SUBSCREEN,
      paymentType,
      value: formatCentsToDollars(cents)
    });
  }, [cents, selectedPaymentType, trackEvent]);
  const handleEmbedMessage = useCallback(message => {
    const {
        payload: {
          type
        }
      } = message,
      restPayload = _objectWithoutPropertiesLoose(message.payload, _excluded2);
    switch (type) {
      case PostMessageType.STRIPE_CHECKOUT_ERROR:
        {
          handleStripeCheckoutError(restPayload);
          break;
        }
      default:
        break;
    }
  }, []);
  const {
    isEmbedded,
    pageName,
    sendMessage,
    siteDomain
  } = useEmbedContext(handleEmbedMessage);
  const getInstallRedirectUrl = useCallback(() => getDownloadedAssetsSuccessUrl({
    downloadedOfferingId: offeringId.toString(),
    pageName,
    siteDomain
  }, offeringType), [offeringId, offeringType, pageName, siteDomain]);
  const handleInstall = useCallback(() => {
    trackDetailsInteraction('click install confirm button');
    setPurchaseRequestState('PENDING');
    const purchaseInfo = {
      offeringId,
      paymentType: selectedPaymentType
    };
    if (selectedPaymentType === PaymentType.STRIPE || selectedPaymentType === PaymentType.PAYPAL) {
      purchaseInfo.successUrl = getInstallRedirectUrl();
      purchaseInfo.cancelUrl = getDetailPageFullUrl(offeringType, slug);
    }
    return purchase(purchaseInfo).then(({
      stripeAccountId,
      stripePublishableKey,
      stripeSessionId,
      paypalCheckoutUrl
    }) => {
      handleTrackInstallUsage();
      setPurchaseRequestState('SUCCEEDED');
      if (selectedPaymentType === PaymentType.FREE) {
        const redirectUrl = getInstallRedirectUrl();
        if (isEmbedded) {
          sendMessage(PostMessageType.REDIRECT_TO_URL, {
            redirectUrl
          });
        } else {
          window.location.replace(redirectUrl);
        }
      } else if (selectedPaymentType === PaymentType.PAYPAL) {
        if (isEmbedded) {
          sendMessage(PostMessageType.REDIRECT_TO_URL, {
            redirectUrl: paypalCheckoutUrl
          });
        } else {
          window.location.replace(paypalCheckoutUrl);
        }
      } else if (selectedPaymentType === PaymentType.STRIPE) {
        if (isEmbedded) {
          sendMessage(PostMessageType.REDIRECT_TO_STRIPE_CHECKOUT, {
            stripeAccountId,
            stripePublishableKey,
            stripeSessionId
          });
        } else {
          const stripe = window.Stripe(stripePublishableKey, {
            stripeAccount: stripeAccountId
          });
          stripe.redirectToCheckout({
            sessionId: stripeSessionId
          }).then(result => {
            setPurchaseRequestState('FAILED');
            handleStripeCheckoutError(result);
          }).catch(error => {
            setPurchaseRequestState('FAILED');
            console.error('error with Stripe purchase\n', error);
          });
        }
      }
    }).catch(error => {
      setPurchaseRequestState('FAILED');
      handleGenericCheckoutError();
      console.error('error initializing purchase\n', error);
    });
  }, [getInstallRedirectUrl, handleTrackInstallUsage, isEmbedded, offeringId, offeringType, selectedPaymentType, sendMessage, slug, trackDetailsInteraction]);
  const renderedCurrency = useMemo(() => {
    if (planType === 'FREE') {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-assets-ui.details.orderSummaryModal.free"
      });
    }
    return /*#__PURE__*/_jsx(CurrencyText, {
      cents: cents
    });
  }, [cents, planType]);
  const [checked, setChecked] = useState(false);
  const renderedDisclaimerPolicy = useMemo(() => {
    const handleChange = () => {
      setChecked(!checked);
    };
    return /*#__PURE__*/_jsx(Checkbox, {
      checked: checked,
      onChange: handleChange,
      "data-test-id": "free-install-disclaimer-checkbox",
      marginBlockEnd: "400",
      children: /*#__PURE__*/_jsx(Small, {
        use: "help",
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "marketplace-assets-ui.details.orderSummaryModal.thirdPartyDisclaimer_jsx",
          elements: {
            Link: ExternalLink
          },
          options: {
            providerTermsLink: {
              href: termsUrl,
              onClick: () => {
                trackDetailsInteraction('click terms link');
              }
            },
            providerPrivacyPolicyLink: {
              href: privacyUrl,
              onClick: () => {
                trackDetailsInteraction('click privacy policy link');
              }
            }
          }
        })
      })
    });
  }, [checked, privacyUrl, termsUrl, trackDetailsInteraction]);
  const renderedPaymentMethods = useMemo(() => {
    if (planType === 'FREE') {
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [renderedDisclaimerPolicy, /*#__PURE__*/_jsx(LoadingButton, {
          "data-test-id": "free-install-confirm-button",
          "data-succeeded": isSucceeded(purchaseRequestState),
          disabled: !checked,
          failed: isFailed(purchaseRequestState),
          loading: isPending(purchaseRequestState),
          onClick: () => handleInstall(),
          use: "primary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplace-assets-ui.details.orderSummaryModal.freeButton"
          })
        })]
      });
    }
    return /*#__PURE__*/_jsxs("div", {
      style: {
        width: '100%'
      },
      children: [/*#__PURE__*/_jsx(H5, {
        color: "fill-accent-blue-default",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-assets-ui.details.orderSummaryModal.paymentMethod"
        })
      }), /*#__PURE__*/_jsx(Flex, {
        flexDirection: "row",
        children: /*#__PURE__*/_jsxs(ToggleGroup, {
          marginBlockEnd: "600",
          name: "paymentMethod",
          inlineSize: "100%",
          children: [stripeEnabled && /*#__PURE__*/_jsx(SelectableRadioInput, {
            marginInlineEnd: "300",
            name: PaymentType.STRIPE,
            onClick: () => {
              setSelectedPaymentType(PaymentType.STRIPE);
              handleTrackInteraction('select payment type', {
                value: PaymentType.STRIPE
              });
            },
            selected: selectedPaymentType === PaymentType.STRIPE,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplace-assets-ui.details.orderSummaryModal.creditCard"
            })
          }), paypalEnabled && /*#__PURE__*/_jsx(SelectableRadioInput, {
            name: PaymentType.PAYPAL,
            onClick: () => {
              setSelectedPaymentType(PaymentType.PAYPAL);
              handleTrackInteraction('select payment type', {
                value: PaymentType.PAYPAL
              });
            },
            selected: selectedPaymentType === PaymentType.PAYPAL,
            children: /*#__PURE__*/_jsx(Image, {
              src: "https://www.paypalobjects.com/webstatic/mktg/Logo/pp-logo-100px.png"
            })
          })]
        })
      }), /*#__PURE__*/_jsx(LoadingButton, {
        use: "primary",
        disabled: selectedPaymentType !== PaymentType.STRIPE && selectedPaymentType !== PaymentType.PAYPAL,
        loading: isPending(purchaseRequestState),
        failed: isFailed(purchaseRequestState),
        onClick: () => handleInstall(),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-assets-ui.details.orderSummaryModal.paidButton"
        })
      })]
    });
  }, [checked, handleInstall, handleTrackInteraction, paypalEnabled, planType, purchaseRequestState, renderedDisclaimerPolicy, selectedPaymentType, stripeEnabled]);
  useEffect(() => {
    trackDetailsPageview({
      subscreen: SUBSCREEN
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return /*#__PURE__*/_jsxs(Modal, {
    "data-test-id": "theme-order-summary-modal",
    width: 600,
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-assets-ui.details.orderSummaryModal.title"
        })
      }), /*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: () => onClose()
      })]
    }), /*#__PURE__*/_jsxs(DialogBody, {
      padding: "0",
      children: [/*#__PURE__*/_jsx(View, {
        paddingInline: "800",
        paddingBlock: "1000",
        children: /*#__PURE__*/_jsxs(TFlex, {
          direction: "row",
          children: [/*#__PURE__*/_jsx(Box, {
            grow: 1,
            children: /*#__PURE__*/_jsxs(MediaObject, {
              itemLeft: /*#__PURE__*/_jsx(Image, {
                blockSize: "110px",
                src: thumbnailUrl,
                role: "presentation"
              }),
              spacing: "medium",
              children: [/*#__PURE__*/_jsx(H5, {
                marginBlockEnd: "100",
                children: name
              }), /*#__PURE__*/_jsx(View, {
                display: "block",
                marginBlockEnd: "200",
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "marketplace-assets-ui.details.orderSummaryModal.providerName",
                  options: {
                    providerName
                  }
                })
              }), /*#__PURE__*/_jsx(Badge, {
                use: "koala",
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: `marketplace-assets-ui.details.offeringType.${offeringType}`
                })
              })]
            })
          }), /*#__PURE__*/_jsx(Box, {
            shrink: 0,
            children: /*#__PURE__*/_jsx(H1, {
              children: renderedCurrency
            })
          })]
        })
      }), /*#__PURE__*/_jsxs(View, {
        paddingBlock: "800",
        paddingInline: "1000",
        as: "div",
        children: [/*#__PURE__*/_jsx(Section, {
          children: renderedPaymentMethods
        }), /*#__PURE__*/_jsx(Section, {
          marginBlockEnd: "0",
          children: /*#__PURE__*/_jsx(Small, {
            use: "help",
            children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
              message: "marketplace-assets-ui.details.orderSummaryModal.legalDisclaimer_jsx",
              elements: {
                Link: ExternalLink
              },
              options: {
                providerName,
                hubspotPrivacyPolicyLink: {
                  href: HUBSPOT_PRIVACY_POLICY_LINK,
                  onClick: () => {
                    trackDetailsInteraction('click product privacy policy link');
                  }
                },
                providerPrivacyPolicyLink: {
                  href: privacyUrl,
                  onClick: () => {
                    trackDetailsInteraction('click privacy policy link');
                  }
                }
              }
            })
          })
        })]
      })]
    })]
  });
}